<template>
  <div class="progress-cnt-parent">
			<div :class="['indeterminate-progress-bar', {'gop-indeterminate-progress-bar' : $route.path.includes('/gop/')}]">
				<div :class="['indeterminate-progress-bar__progress', {'gop-indeterminate-progress-bar__progress' : $route.path.includes('/gop/')}]"></div>
			</div>
	</div>
</template>
<script>
export default {
	name: "ProgressBar"
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.progress-cnt-parent{
		position: fixed;
		z-index: 101;
		top: 65px;
    width: 100%;
}

.indeterminate-progress-bar {
	/* Color */
	background-color: rgba(253, 183, 26, 0.38);

	/* Rounded border */
	border-radius: 9999px;

	/* Size */
	height: 5px;

	position: relative;
	overflow: hidden;
}

.gop-indeterminate-progress-bar {
	background-color: #d9fafa
}

.indeterminate-progress-bar__progress {
	/* Color */
	background-color: #fdb71a;

	/* Rounded border */
	border-radius: 9999px;

	/* Absolute position */
	position: absolute;
	bottom: 0;
	top: 0;
	width: 50%;

	/* Move the bar infinitely */
	animation-duration: 1.6s;
	animation-iteration-count: infinite;
	animation-name: indeterminate-progress-bar;
}

.gop-indeterminate-progress-bar__progress {
	background-color: $gop-blue;
}

@keyframes indeterminate-progress-bar {
	from {
		left: -50%;
	}
	to {
		left: 100%;
	}
}
</style>
